import { render, staticRenderFns } from "./centralStatistics.vue?vue&type=template&id=37fa50c4&scoped=true"
import script from "./centralStatistics.vue?vue&type=script&lang=js"
export * from "./centralStatistics.vue?vue&type=script&lang=js"
import style0 from "./centralStatistics.vue?vue&type=style&index=0&id=37fa50c4&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fa50c4",
  null
  
)

export default component.exports